import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetSR_SubTypeList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'SR_SubType/GetAllSR_SubTypeList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewSR_SubType = async (SR_SubTypeDet) => {
    //debugger;
    //console.log(JSON.stringify(SR_SubTypeDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `SR_SubType/CreateNewSR_SubType`, 
        JSON.stringify(SR_SubTypeDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateSR_SubType = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SR_SubType/ActivateDeActivateSR_SubType?SR_SubTypeId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateSR_SubType = async(SR_SubTypeDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'SR_SubType/UpdateSR_SubType', 
        JSON.stringify(SR_SubTypeDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}